export default {
  table: {
    width: '100%'
  },
  'th, td': {
    borderBottom: '.1rem solid #e1e1e1',
    padding: '1.2rem 1.5rem',
    textAlign: 'left',
    '&:first-child': {
      paddingLeft: 0
    },
    '&:last-child': {
      paddingRight: 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/globalStyles/table.js